var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('payment-method-form',{attrs:{"holder-type":_vm.holderType,"holder-id":_vm.holderId,"loading":_vm.loading,"paymentMethodData":_vm.paymentMethod,"formErrors":_vm.formErrors},on:{"paymentMethodSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }